'use strict';
var parent = require('../../es/iterator/find');

module.exports = parent;
